import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import router from '../Routes'
import swal from 'sweetalert2'
import store from '@/store/index'

Vue.use(Vuex)
const fb = require('../firebaseConfig.js')

// handle page reload

function fetchDB (uid)
{
  return new Promise(function (resolve, reject) {
    fb.usersCollection.doc(uid).get().then(function (uuu) {

      var profile = {}
      if (uuu.exists)
      {
        profile = uuu.data()
      }

      profile.uid = uid

      if (!profile.fullName)
      {
        profile.fullName = 'CrazyTrip User'
      }

      if (!profile.profilePicture)
      {
        profile.profilePicture = '/img/default-avatar.png'
      }

      resolve(profile)
    })
  })
}

export default {
  namespaced: true,

  state:     {
    userProfiles: [],

  },
  mutations: {
    addProfile (state, val)
    {
      state.userProfiles[val.uid] = val
    },

    updateProfile (state, profile)
    {
      var that = this

      profile.fullName     = profile.fullName || ''
      profile.jobTitle     = profile.jobTitle || ''
      profile.primaryPhone = profile.primaryPhone || ''
      profile.city         = profile.city || ''
      profile.country      = profile.country || ''
      profile.shortBio     = profile.shortBio || ''
      profile.bio          = profile.bio || ''

      fb.usersCollection.doc(profile.uid).update
      ({
        updatedOn: new Date(),

        fullName:     profile.fullName,
        jobTitle:     profile.jobTitle,
        primaryPhone: profile.primaryPhone,
        city:         profile.city,
        country:      profile.country,
        shortBio:     profile.shortBio,
        bio:          profile.bio,

      }).then(ref => {
        that.commit('userProfiles/addProfile', profile)

      }).catch(err => {

        console.log(err)
      })

    },
  }, // mutations

  actions: {

    clearProfile (context, uid)
    {
      var that = this

      delete that.getters['userProfiles/userProfiles'][uid]
    },
    retreiveProfile (context, uid)
    {
      var that = this
      return new Promise(function (resolve, reject) {

        if (that.getters['userProfiles/userProfiles'][uid])
        {
          resolve(that.getters['userProfiles/userProfiles'][uid])
          return
        }

        fetchDB(uid).then(function (profile) {

          profile.fullName     = profile.fullName || ''
          profile.title        = profile.title || ''
          profile.primaryPhone = profile.primaryPhone || ''
          profile.city         = profile.city || ''
          profile.country      = profile.country || ''
          profile.shortBio     = profile.shortBio || ''
          profile.bio          = profile.bio || ''

          that.commit('userProfiles/addProfile', profile)

          resolve(profile)

        }).catch(function () {
          reject()
        })

      })

    },
    retreiveProfiles (context, uids)
    {
      var promises = []
      var that     = this

      uids = [...new Set(uids)] // get unique vals

      uids.forEach(function (uid) {

        var promise = context.dispatch('retreiveProfile', uid)

        promises.push(promise)
      })

      return Promise.all(promises)
    }
  }, // actions

  getters: {
    userProfiles (state)
    {
      return state.userProfiles
    },

    currentUserProfile (state)
    {
      return state.userProfile
    },

  },
}
